import { getOptimizedImgSrc } from './getOptimizedImgSrc';

export function getCssResponsiveImageSet({ src, width }: { src: string; width: number }): string {
  const rWidth = Math.round(width);
  return `image-set( url(${getOptimizedImgSrc({
    src,
    width: rWidth,
    format: 'webp',
    quality: 70,
  })}) 1x, url(${getOptimizedImgSrc({
    src,
    width: rWidth * 2,
    quality: 40,
    format: 'webp',
  })}) 2x)`;
}
